import { action, makeObservable, runInAction } from 'mobx';
import { createContext, useContext } from 'react';
import { bpHistory } from 'global/bpHistory';
import IEnrollmentCensusReviewPageStore from 'store/modules/census/enrollment-based/iEnrollmentCensusReviewPageStore';
import { CensusReviewDomainParams } from 'store/modules/census/iCensusReviewPageStore';
import { requestApplyUserAction } from 'api/operations/enrollmentService';
import { USER_ACTIONS } from 'types/enrollmentService';

/* TESTING_POLICY: CYPRESS_ONLY */

/** @deprecated  This is an old standalone page, the newer approach renders it as a part of the add-employees page. */
export default class CensusStatisticsEnrollmentPageStore extends IEnrollmentCensusReviewPageStore {
  protected _domainData;

  public onBackRedirect(): void {
    bpHistory.push(`/census/${this._domainData.groupId}/${this._domainData.enrollmentPeriodId}`);
  }

  public async onCompleteRedirect(): Promise<void> {
    await runInAction(async () => {
      await requestApplyUserAction(this._domainData.enrollmentPeriodId, USER_ACTIONS.COMPLETE_CENSUS_IMPORT);
    });
    bpHistory.push(`/checklist/${this._domainData.enrollmentPeriodId}`);
  }

  constructor(domainData: CensusReviewDomainParams) {
    super();

    this._domainData = domainData;

    makeObservable<CensusStatisticsEnrollmentPageStore>(this, {
      onBackRedirect: action.bound,
      onCompleteRedirect: action.bound,
    });
  }
}

/** @deprecated  This is an old standalone page, the newer approach renders it as a part of the add-employees page. */
const CensusStatisticsEnrollmentPageStoreContext = createContext(
  new CensusStatisticsEnrollmentPageStore({} as CensusReviewDomainParams),
);

/** @deprecated  This is an old standalone page, the newer approach renders it as a part of the add-employees page. */
export const useCensusStatisticsEnrollmentPageStore = (): CensusStatisticsEnrollmentPageStore => {
  return useContext(CensusStatisticsEnrollmentPageStoreContext);
};

export { CensusStatisticsEnrollmentPageStoreContext };
